import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "text-center me-3" }
const _hoisted_5 = { class: "fs-lg-8" }
const _hoisted_6 = { class: "ms-3 fw-bold" }
const _hoisted_7 = {
  key: 0,
  id: "pickup-sessions"
}
const _hoisted_8 = {
  key: 1,
  class: "mt-7 mb-5",
  id: "category-filter"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, "カテゴリで絞り込む", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 fs-lg-6" }, "下記のタイムテーブルを選択したカテゴリでハイライトさせます。", -1)
const _hoisted_11 = { class: "mb-4 row row-cols-2 row-cols-lg-6 g-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "icon icon-me-2 icon-start icon-check" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3 session-timetable-h2" }, "タイムテーブル", -1)
const _hoisted_18 = { class: "toc-anchor" }
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "mb-3 nav nav-tabs fw-bold" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "fs-6 table table-striped table-bordered align-top" }
const _hoisted_23 = { class: "text-center text-nowrap fs-lg-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = {
  key: 3,
  class: "mt-n5 py-7 text-center session-timetable-submit-btn"
}
const _hoisted_27 = { class: "webpan-large" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 0,
  class: "mb-3 text-center"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "mb-3 session-social-share d-flex justify-content-center align-items-center flex-wrap"
}
const _hoisted_32 = { class: "mb-2 d-flex align-items-center h-100" }
const _hoisted_33 = ["data-text"]
const _hoisted_34 = { class: "mb-2 d-flex align-items-center h-100" }
const _hoisted_35 = ["data-href"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "me-3 mb-2 d-flex align-items-center h-100" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://b.hatena.ne.jp/entry/",
    class: "hatena-bookmark-button",
    "data-hatena-bookmark-layout": "basic-label-counter",
    "data-hatena-bookmark-lang": "ja",
    "data-hatena-bookmark-height": "28",
    title: "このエントリーをはてなブックマークに追加"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://b.st-hatena.com/images/v4/public/entry-button/button-only@2x.png",
      alt: "このエントリーをはてなブックマークに追加",
      width: "20",
      height: "20",
      style: {"border":"none"}
    })
  ])
], -1)
const _hoisted_37 = { class: "me-3 mb-2 d-flex align-items-center h-100" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "note", -1)
const _hoisted_40 = { class: "mb-2 d-flex align-items-center h-100" }
const _hoisted_41 = ["data-url"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "py-7 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "webpan-large" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "/",
      class: "px-2 px-lg-5 btn btn-lg btn-accent2 fw-bold"
    }, "他のタイムテーブルも見る")
  ])
], -1)

import { ref, toRaw, computed } from 'vue';
  import SessionView from '@/components/SessionView.vue';
  import PickupSessionView from '@/components/PickupSessionView.vue';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  props: {
    single: { type: Boolean },
    sessions: { type: Object },
    login: { type: Boolean },
    cart: { type: Object },
    entryList: { type: Object },
    seminar_session: { type: String },
    shareURL: { type: String },
    webinarMainLabel: { type: String },
    webinarSubLabel: { type: String },
    eventHolding: { type: Boolean },
    eventAPIisAlive: { type: Boolean },
    linkBaseURL: { type: String }
  },
  emits: ['addItem', 'removeItem', 'cancelItem', 'submitForm'],
  setup(__props, { emit: emits }) {

const props = __props;

  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  

  const addItem = (id: string) => {
    emits('addItem', id);
  }

  const removeItem = (id: string) => {
    emits('removeItem', id);
  }

  const cancelItem = (session: object) => {
    emits('cancelItem', session);
  }

  const submitForm = () => {
    emits('submitForm');
  }

  const categories = computed( // カテゴリのリスト
    () => {
      let temp = [];
      let tempCats = [];
      props.sessions.forEach((session) => {
        session.categories.forEach((category) => {
          temp.push(category);
        });
      });
      temp = Array.from(new Set(temp)); // ユニークにする
      temp.forEach((category) => {
        tempCats.push({ name: category, active: true });
      });
      return tempCats;
    }
  );

  const calendarTabs = computed( // 開催日のリスト
    () => {
      let temp = [];
      props.sessions.forEach((session) => {
        if (session.dateLabel) {
          temp.push(session.dateLabel);
        }
      });
      temp = Array.from(new Set(temp)); // ユニークにする
      temp.sort((a, b) => {
        return a > b;
      });
      return temp;
    }
  );

  const singleSession = computed( // 詳細ページのセッション
    () => {
      let temp = {};
      temp = props.sessions.find((session) => {
        return session.id === props.seminar_session;
      });
      temp = toRaw(temp);
      return temp;
    }
  );

  const ogImagesJSON = window.webtanOgImagesJSON;
  const ogimage = computed( // og:image
    () => {
      let temp = {};
      let url = '';
      if (props.single) {
        if (ogImagesJSON.length) {
          temp = ogImagesJSON.find((item) => {
            return item.id === props.seminar_session;
          });
        }
      }
      if (temp.url) {
        url = temp.url;
      }
      return url;
    }
  );

  const pickupSessionsJSON = window.webtanPickupSessionsJSON;
  const pickupSessions = computed( // 注目のセッション
    () => {
      let temp = [];
      if (!props.single) {
        if (pickupSessionsJSON.length) {
          pickupSessionsJSON.forEach((str) => {
            props.sessions.forEach((session) => {
              if (session.id === str) {
                temp.push(toRaw(session));
              }
            });
          });
        }
      }
      return temp;
    }
  );

  let timetable = computed( // タイムテーブル
    () => {
      let days = [];
      if (!props.single) {
        props.sessions.forEach((session) => {
          const day = days.find((day) => { return day.date === session.date });
          if (!day) {
            days.push({
              date: session.date,
              dateLabel: session.dateLabel,
              cols: 1,
              timebox: []
            });
          }
          days.find((day) => {
            if (day.date === session.date) {
              const time = session.timeStart + '-' + session.timeEnd;
              const timebox = day.timebox.find((timebox) => { return timebox.time === time });
              if (!timebox) {
                day.timebox.push({
                  time: time,
                  timeStart: session.timeStart,
                  timeEnd: session.timeEnd,
                  cols: 1,
                  sessions: []
                });
              }
              day.timebox.find((timebox) => {
                if (timebox.time === time) {
                  timebox.sessions.push(toRaw(session));
                }
              })
            }
          });
        });
        days.forEach((day) => { // カラム幅の計算
          day.timebox.forEach((timebox) => {
            timebox.cols = timebox.sessions.length;
            if (day.cols < timebox.cols) {
              day.cols = timebox.cols;
            }
          });
        });
      }
      return days;
    }
  );

  let isFiltered = ref(false);
  let filteredList = ref([]);
  let filteredListLabel = computed(
    () => {
      let temp = '';
      if (filteredList.value) {
        temp = filteredList.value.join(', ');
      }
      return temp;
    }
  );
  const toggleFilter = (i: number) => {
    if (isFiltered.value) {
      categories.value[i].active = !categories.value[i].active;
      const pos = filteredList.value.indexOf(categories.value[i].name);
      if (pos != -1) {
        filteredList.value.splice(pos, 1);
      } else {
        filteredList.value.push(categories.value[i].name);
      }
    } else {
      isFiltered.value = true;
      categories.value.forEach((category, index) => {
        categories.value[index].active = false;
      });
      categories.value[i].active = !categories.value[i].active;
      filteredList.value.push(categories.value[i].name);
    }
  }

  const toggleFilterAll = () => {
    isFiltered.value = false;
    filteredList.value = [];
    categories.value.forEach((category, index) => {
      categories.value[index].active = true;
    });
  }

  const isFilteredSession = (session: object) => {
    if (isFiltered.value) {
      let flag = false;
      filteredList.value.forEach((listItem) => {
        if (session.categories.includes(listItem)) {
          flag = true;
        }
      });
      return flag;
    } else {
      return false;
    }
  }

  const isCartInSession = (session: object) => {
    console.log('session', session);
    if (session && session.layout_id) {
      if (props.cart.includes(session.layout_id.toString())) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const isEnrtySession = (session: object) => {
    if (session && session.layout_id) {
      if (props.entryList.includes(session.layout_id.toString())) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.single)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_unref(isFiltered))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["session-filter-fixed", _unref(isFiltered) ? 'bg-light py-2 px-3 position-fixed top-0 start-0' : '']),
                      style: {"z-index":"999"}
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFilterAll())),
                            class: "text-nowrap btn btn-sm fw-bold btn-outline-primary fs-lg-8"
                          }, "クリア")
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createTextVNode("絞り込み:"),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(filteredListLabel)), 1)
                        ])
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (!__props.login)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pickupSessions), (session, p) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "my-4",
                    key: p
                  }, [
                    _createVNode(PickupSessionView, {
                      session: session,
                      onAddItem: addItem,
                      onRemoveItem: removeItem,
                      onCancelItem: cancelItem,
                      isFilteredSession: isFilteredSession(session),
                      isFiltered: _unref(isFiltered),
                      login: __props.login,
                      isCartInSession: isCartInSession(session),
                      isEnrtySession: isEnrtySession(session),
                      webinarMainLabel: __props.webinarMainLabel,
                      webinarSubLabel: __props.webinarSubLabel,
                      eventHolding: __props.eventHolding,
                      eventAPIisAlive: __props.eventAPIisAlive,
                      linkBaseURL: __props.linkBaseURL
                    }, null, 8, ["session", "isFilteredSession", "isFiltered", "login", "isCartInSession", "isEnrtySession", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive", "linkBaseURL"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!__props.login)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col",
                      key: i
                    }, [
                      (_unref(isFiltered))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: ($event: any) => (toggleFilter(i)),
                            class: _normalizeClass(["w-100 h-100 btn btn-sm fw-bold fs-lg-8", category.active ? 'btn-outline-primary' : 'btn-outline-secondary'])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(category.active ? 'icon icon-me-2 icon-start icon-check' : 'icon icon-me-2 icon-start icon-transparent')
                            }, _toDisplayString(category.name), 3)
                          ], 10, _hoisted_12))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: ($event: any) => (toggleFilter(i)),
                            class: "w-100 h-100 btn btn-sm fw-bold btn-outline-primary fs-lg-8"
                          }, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(category.name), 1)
                          ], 8, _hoisted_13))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleFilterAll())),
                    class: "btn btn-sm fw-bold btn-outline-primary fs-lg-8"
                  }, "絞り込みをクリア")
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(timetable))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timetable), (day, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-7",
                    key: i
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", {
                        id: day.dateLabel
                      }, null, 8, _hoisted_19)
                    ]),
                    _createElementVNode("ul", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calendarTabs), (tab, j) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "nav-item",
                          key: j
                        }, [
                          _createElementVNode("a", {
                            href: '#' + tab,
                            class: _normalizeClass(["nav-link text-decoration-none link-dark timetable-nav-link", day.dateLabel === tab ? 'active fs-2 d-block' : 'fs-4 pt-3 d-none d-lg-block'])
                          }, _toDisplayString(tab), 11, _hoisted_21)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("table", _hoisted_22, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.timebox, (timebox, k) => {
                          return (_openBlock(), _createElementBlock("tr", { key: k }, [
                            _createElementVNode("th", _hoisted_23, [
                              _createTextVNode(_toDisplayString(timebox.timeStart), 1),
                              _hoisted_24,
                              _createTextVNode("～"),
                              _hoisted_25,
                              _createTextVNode(_toDisplayString(timebox.timeEnd), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["mb-3 row row-cols-1 gx-0 gy-3 gx-lg-3", ['row-cols-lg-' + day.cols, 'sessions-max-cols-' + day.cols]])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timebox.sessions, (session, m) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "col",
                                    key: m
                                  }, [
                                    _createVNode(SessionView, {
                                      session: session,
                                      onAddItem: addItem,
                                      onRemoveItem: removeItem,
                                      onCancelItem: cancelItem,
                                      isFilteredSession: isFilteredSession(session),
                                      isFiltered: _unref(isFiltered),
                                      login: __props.login,
                                      isCartInSession: isCartInSession(session),
                                      isEnrtySession: isEnrtySession(session),
                                      webinarMainLabel: __props.webinarMainLabel,
                                      webinarSubLabel: __props.webinarSubLabel,
                                      eventHolding: __props.eventHolding,
                                      eventAPIisAlive: __props.eventAPIisAlive,
                                      linkBaseURL: __props.linkBaseURL
                                    }, null, 8, ["session", "isFilteredSession", "isFiltered", "login", "isCartInSession", "isEnrtySession", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive", "linkBaseURL"])
                                  ]))
                                }), 128))
                              ], 2)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!__props.login)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-2 px-lg-5 btn btn-lg btn-accent2 fw-bold fs-lg-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm()))
                  }, "参加申込する（無料）")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.single)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          (_unref(ogimage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("img", {
                  src: _unref(ogimage),
                  class: "img-fluid rounded",
                  alt: ""
                }, null, 8, _hoisted_30)
              ]))
            : _createCommentVNode("", true),
          (_unref(singleSession))
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("a", {
                    href: "https://twitter.com/share?ref_src=twsrc%5Etfw",
                    class: "twitter-share-button",
                    "data-size": "large",
                    "data-text": _unref(singleSession).title.replace(/<(.*?)>/g, ''),
                    "data-via": "webtanforum",
                    "data-hashtags": "Web担当者Forum",
                    "data-lang": "ja",
                    "data-show-count": "true"
                  }, "Tweet", 8, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: "fb-share-button mx-3 rounded-pill",
                    "data-href": __props.shareURL,
                    "data-layout": "button_count",
                    "data-size": "large"
                  }, null, 8, _hoisted_35)
                ]),
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("a", {
                    href: 'https://note.com/intent/post?url=' + __props.shareURL,
                    target: "_blank",
                    rel: "noopener",
                    class: "note-share-btn"
                  }, [
                    _hoisted_39,
                    _createTextVNode("で書く")
                  ], 8, _hoisted_38)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", {
                    class: "line-it-button",
                    "data-lang": "ja",
                    "data-type": "share-a",
                    "data-env": "REAL",
                    "data-url": __props.shareURL,
                    "data-color": "default",
                    "data-size": "large",
                    "data-count": "false",
                    "data-ver": "3",
                    style: {"display":"none"}
                  }, null, 8, _hoisted_41)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(singleSession))
            ? (_openBlock(), _createBlock(PickupSessionView, {
                key: 2,
                single: __props.single,
                session: _unref(singleSession),
                onAddItem: addItem,
                onRemoveItem: removeItem,
                onCancelItem: cancelItem,
                isFilteredSession: isFilteredSession(_unref(singleSession)),
                isFiltered: _unref(isFiltered),
                login: __props.login,
                isCartInSession: isCartInSession(_unref(singleSession)),
                isEnrtySession: isEnrtySession(_unref(singleSession)),
                webinarMainLabel: __props.webinarMainLabel,
                webinarSubLabel: __props.webinarSubLabel,
                eventHolding: __props.eventHolding,
                eventAPIisAlive: __props.eventAPIisAlive,
                linkBaseURL: __props.linkBaseURL
              }, null, 8, ["single", "session", "isFilteredSession", "isFiltered", "login", "isCartInSession", "isEnrtySession", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive", "linkBaseURL"]))
            : _createCommentVNode("", true),
          _hoisted_42
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})